"use strict";
// Copyright © Veeam Software Group GmbH
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const SVG_1 = __importDefault(require("./SVG"));
const Icon = (0, styled_components_1.default)(SVG_1.default) `
    polygon {
        fill: #e8595a;
    }
`;
exports.default = (props) => (react_1.default.createElement(Icon, { viewBox: "0 0 12 12", xmlns: "http://www.w3.org/2000/svg" },
    react_1.default.createElement("polygon", { points: "7.42 6 12 1.42 10.58 0 6 4.58 1.42 0 0 1.42 4.58 6 0 10.58 1.42 12 6 7.42 10.58 12 12 10.58 7.42 6" })));
//# sourceMappingURL=Ignore.js.map